import { useScrollLock } from '@vueuse/core'
import { readonly, type Ref } from 'vue'

interface UseBodyScrollLockReturn {
  isLocked: Readonly<Ref<boolean>>
  // eslint-disable-next-line no-unused-vars
  setIsLocked: (locked: boolean) => void
}

const isLocked = useScrollLock(document.body, false)

export function useBodyScrollLock(): UseBodyScrollLockReturn {
  function setIsLocked(locked: boolean) {
    isLocked.value = locked
  }

  return { isLocked: readonly(isLocked), setIsLocked }
}
